import { render, staticRenderFns } from "./batch_adjust.vue?vue&type=template&id=a6856890&scoped=true&"
import script from "./batch_adjust.vue?vue&type=script&lang=js&"
export * from "./batch_adjust.vue?vue&type=script&lang=js&"
import style0 from "./batch_adjust.vue?vue&type=style&index=0&id=a6856890&scoped=true&lang=css&"
import style1 from "./batch_adjust.vue?vue&type=style&index=1&id=a6856890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6856890",
  null
  
)

export default component.exports